import { createContext } from 'react';
import { PayBenchmarkingHook } from 'apps/sigma2-ui/src/pay-benchmarking/hooks/PayBenchmarkingHook';

export const PayBenchmarkingContext = createContext<PayBenchmarkingHook>({
  selectableBenchmarks: [],
  selectedBenchmark: null,
  setSelectedBenchmark: () => {},
  selectableDepartments: [],
  selectedDepartment: null,
  setSelectedDepartment: () => {},

  selectableRoles: [],
  selectedRole: null,
  setSelectedRole: () => {},

  selectableLevels: [],
  selectedLevel: null,
  setSelectedLevel: () => {},

  selectableLocations: [],
  selectedLocation: null,
  setSelectedLocation: () => {},

  selectedExperience: null,
  setSelectedExperience: () => {},

  selectableEducationLabels: [],
  selectedEducationLabel: null,
  setSelectedEducationLabel: () => {},

  selectableCurrencies: [],
  selectedCurrency: null,
  setSelectedCurrency: () => {},

  selectableCompensationUnits: [],
  selectedCompensationUnit: 'salary',
  setSelectedCompensationUnit: () => {},

  canApplyFilters: false,
  onApplyFilters: () => {},

  currentState: {
    state: 'empty_state',
  },

  generateShareLink: async () => {
    return;
  },

  onUserAnalysisCancel: () => {},
});
